import { gql } from "@apollo/client";

export const GET_OVERVIEW_METRICS_REPORT = gql`
  query GetOverviewMetricsReport(
    $attributionMethod: String!
    $accountingMode: String!
    $attributionWindow: String!
    $attributionWindows: [String!]
    $level: String
    $timeGranularity: String!
    $dateRange: JSONObject!
    $breakdowns: [String!]
    $breakdownFilters: [[String!]!]
    $filters: [SalesTableReportV3BreakdownsFilterInput]
    $metrics: [String!]!
    $aggregateAll: Boolean
    $disableDateCompression: Boolean
    $conversionLag: Boolean
    $searchQuery: String
    $advancedSearch: JSONObject
    $disableAttributionWindowOverwriteInCashMode: Boolean
  ) {
    me {
      overviewMetricsReport(
        attributionMethod: $attributionMethod
        accountingMode: $accountingMode
        attributionWindow: $attributionWindow
        attributionWindows: $attributionWindows
        level: $level
        timeGranularity: $timeGranularity
        dateRange: $dateRange
        breakdowns: $breakdowns
        breakdownFilters: $breakdownFilters
        filters: $filters
        metrics: $metrics
        aggregateAll: $aggregateAll
        disableDateCompression: $disableDateCompression
        conversionLag: $conversionLag
        searchQuery: $searchQuery
        advancedSearch: $advancedSearch
        disableAttributionWindowOverwriteInCashMode: $disableAttributionWindowOverwriteInCashMode
      ) {
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }
        rows {
          dimensions
          metrics
        }
        effectiveTimeGranularity
      }
    }
  }
`;

export const GET_OVERVIEW_METRICS_REPORT_V2 = gql`
  query GetOverviewMetricsReportV2(
    $attributionMethod: String!
    $accountingMode: String!
    $attributionWindow: String!
    $attributionWindows: [String!]
    $level: String
    $timeGranularity: String!
    $dateRange: JSONObject!
    $compareDateRange: JSONObject
    $breakdowns: [String!]
    $breakdownFilters: [[String!]!]
    $filters: [SalesTableReportV3BreakdownsFilterInput]
    $metrics: [String!]!
    $aggregateAll: Boolean
    $disableDateCompression: Boolean
    $conversionLag: Boolean
    $searchQuery: String
  ) {
    me {
      overviewMetricsReportV2(
        attributionMethod: $attributionMethod
        accountingMode: $accountingMode
        attributionWindow: $attributionWindow
        attributionWindows: $attributionWindows
        level: $level
        timeGranularity: $timeGranularity
        dateRange: $dateRange
        compareDateRange: $compareDateRange
        breakdowns: $breakdowns
        breakdownFilters: $breakdownFilters
        filters: $filters
        metrics: $metrics
        aggregateAll: $aggregateAll
        disableDateCompression: $disableDateCompression
        conversionLag: $conversionLag
        searchQuery: $searchQuery
      ) {
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }

        mainData {
          rows {
            dimensions
            metrics
          }
          effectiveTimeGranularity
        }
        compareData {
          rows {
            dimensions
            metrics
          }
          effectiveTimeGranularity
        }
      }
    }
  }
`;

export const GET_LABEL_RULES_V3 = gql`
  query GetLabelRulesV3 {
    me {
      id
      labelRulesV3 {
        id
        level
        labelKey
        active
        createdAt
        updatedAt
        labelRules
      }
    }
  }
`;
